import { render, staticRenderFns } from "./Hint.vue?vue&type=template&id=21726c75&scoped=true&"
import script from "./Hint.vue?vue&type=script&lang=ts&"
export * from "./Hint.vue?vue&type=script&lang=ts&"
import style0 from "./Hint.vue?vue&type=style&index=0&id=21726c75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21726c75",
  null
  
)

export default component.exports